import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Phone, Mail, ArrowRight } from "lucide-react";
import { BUSINESS } from "../../lib/constants";

export function ContactCTA() {
  return (
    <section className="py-24 bg-carbon border-t border-amber-500/10" data-testid="contact-cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 items-center">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <span className="text-xs font-mono uppercase tracking-[0.25em] text-amber-light">Downtime Costs Money</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase text-white mt-2 mb-5">Get A Quote In Hours, Not Days</h2>
          <p className="text-zinc-400 max-w-md mb-8 leading-relaxed">
            Tell us your vehicle, part SKU, or general need — our technicians respond directly with pricing and lead-time.
          </p>
          <Link
            to="/quote"
            data-testid="contact-cta-quote-button"
            className="inline-flex items-center gap-2 bg-amber-light text-obsidian font-semibold px-7 py-3.5 rounded-sm uppercase text-sm tracking-wide hover:bg-white transition-colors duration-300"
          >
            Request a Quote <ArrowRight className="h-4 w-4" />
          </Link>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }} className="border border-amber-500/15 rounded-md p-8 bg-obsidian">
          <h3 className="font-mono text-xs uppercase tracking-widest text-amber-light mb-6">Direct Contact</h3>
          <div className="space-y-4">
            <a href={`tel:${BUSINESS.phoneRaw}`} className="flex items-center gap-3 text-white hover:text-amber-light" data-testid="contact-phone-link">
              <Phone className="h-4 w-4 text-amber-light" /> {BUSINESS.phone}
            </a>
            {BUSINESS.emails.map((e) => (
              <a key={e} href={`mailto:${e}`} className="flex items-center gap-3 text-zinc-300 hover:text-amber-light" data-testid={`contact-email-link-${e}`}>
                <Mail className="h-4 w-4 text-amber-light" /> {e}
              </a>
            ))}
          </div>
          <p className="text-xs text-zinc-500 mt-6">{BUSINESS.address}</p>
        </motion.div>
      </div>
    </section>
  );
}
